import React, {useState} from "react";
import {Alert, Form, Modal} from "react-bootstrap";
import {database, firestore} from "../../firebase";
import _ from "lodash";

import {useDispatch, useSelector} from "react-redux";

import ReelerTooltip from "../../components/commons/ReelerTooltip/ReelerTooltip";
import ReelerButton from "../../components/commons/ReelerButton";

import SpinnerComponent from "../../components/commons/SpinnerComponent";
import {selectBulkEditArray} from "../../redux/bulk-edit/bulkEdit.selectors";
import useUserFeedbackMessage from "../../hooks/useUserFeedbackMessage";
import {BulkEditReset} from "../../redux/bulk-edit/bulkEdit.actions";

export default function RestoreAssets() {
  const dispatch = useDispatch();
  const [restoreLableStr, setRestoreLableStr] = useState("");
  const assetArray = useSelector(selectBulkEditArray);
  const [open, setOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  const [isRestoring, setIsRestoring] = useState(false);
  const [loading, setLoading] = useState(false);

  const {setSuccessMessage, setErrorMessage} = useUserFeedbackMessage();

  function openModal() {
    setOpen(true);
  }

  function closeModal() {
    setOpen(false);
  }

  const restoreAssets = async () => {
    const batchSize = 125; // Antal dokument att hantera per batch

    let restoreLable = {};

    restoreLableStr
      .toLowerCase()
      .replace(/#+/g, "")
      .split(" ")
      .forEach((tag) => {
        if (tag === "") {
          return;
        }
        restoreLable[tag] = true;
      });

    const batchPromises = _.chunk(assetArray, batchSize).map((assetDocs) => {
      const batch = firestore.batch();
      assetDocs.forEach((asset) => {
        let restoredAssetRef = database.assets.doc(asset.id);
        let deletedAssetRef = database.deletedAssets.doc(asset.id);

        const tags = {
          ...asset.tags,
          ...restoreLable,
        };

        const restoredAsset = {
          ...asset,
          restoredAt: database.getCurrentTimestamp(),
          deletedAt: null,
          tags,
        };

        batch.set(restoredAssetRef, restoredAsset);
        batch.delete(deletedAssetRef);
      });
      return batch.commit();
    });

    await Promise.all(batchPromises);
  };

  const handleRestoreAssets = async () => {
    if (!confirmed) return;

    setIsRestoring(true);

    restoreAssets()
      .then(() => {
        setIsRestoring(false);
        setSuccessMessage("Assets restored successfully");
        dispatch(BulkEditReset());
        closeModal();
      })
      .catch((err) => {
        console.log(err);
        setIsRestoring(false);
        setErrorMessage("There was an error restoring the assets");
      });
  };

  return (
    <>
      <ReelerTooltip text={"Restore selected assets"} placement="bottom">
        <ReelerButton
          text={"Restore " + assetArray.length + " assets"}
          styleClass="btn-main"
          dispatch={() => openModal()}
        />
      </ReelerTooltip>

      <Modal size="lg" centered show={open} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            Are you sure you want to restore these assets?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isRestoring ? (
            <>
              <Alert variant="warning">
                <Alert.Heading>Attention</Alert.Heading>
                <p>
                  Please remain on this page until the process is complete to
                  avoid interrupting the restoration.
                </p>
              </Alert>
              <SpinnerComponent />
            </>
          ) : (
            <>
              <p>
                You have selected <strong>{assetArray.length}</strong> assets to
                restore.
              </p>

              <Form.Group className="mb-3">
                <Form.Label>Optioal: Add a restoration label</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g. restored, recovered"
                  onChange={(e) => setRestoreLableStr(e.target.value)}
                />
                <Form.Text className="text-muted">
                  This label will be added to the restored assets so you can
                  easily find them later.
                </Form.Text>
              </Form.Group>

              <p>Confirm restoration by typing yes in the field below.</p>
              <Form.Group controlId="url-link">
                <Form.Control
                  type="text"
                  required
                  placeholder="Type yes"
                  onChange={(e) =>
                    e.target.value === "yes"
                      ? setConfirmed(true)
                      : setConfirmed(false)
                  }
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <ReelerButton
            text="Close"
            dispatch={closeModal}
            styleClass="btn-secondary"
          />
          <ReelerButton
            text="Restore selcted assets"
            styleClass="btn-main"
            dispatch={() => handleRestoreAssets()}
            loading={isRestoring}
            disabled={!confirmed || isRestoring}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}
